<div class="container">
    <section class="inner-container">
<div class="products" style="background: white; ">
  <div class="content-container">
    <div class="text-center">
      <h1 class="title-default intro-title">Cards Payment Gateway UAT/ Live Data</h1>
      <hr class="yellow-line-large">
      <p class="text-intro"></p>


    </div>
    <div class="inner">
      <div class="flex-wrap scroll_cards_uat_live">
            <form name="offer-letter-form" id="offer-letter-form" data-k2-validation="true" novalidate class="col-sm-10" style="padding: 0" (ngSubmit)="submit(true)">
              
              <div class="row">
                <div class="col-md-12 text-center" >
                  <h3 class="vmid"> Please download the Development Guide and implement with the data given below.<br/> 

                  </h3>
                </div>

                <div class="col-md-6 col-md-offset-3 text-center">
                  <a #cardGuideDownload download [href]="'assets/cards/maybank_eBPG_dev_guide.pdf'" class="btn btn-primary btn-block center" >Download Development Guide<i class="ti-download" aria-hidden="true"></i></a>
                </div>
              </div>

              

              <h5 class="title-light"> VISA / MASTERCARD</h5>
              <div class="row">
                <div class="row ">
                  <div class="box-uat col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant Account Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_mid+mids?.vm_tid}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant ID:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_mid}}</h3>
                        </div>
                      </div>


                      <div class="row">
                        <div class="col-md-6">
                          <h3>UAT HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_uat_hashkey}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Prod HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_prod_hashkey}}</h3>
                        </div>
                      </div>
                    </div>
                </div>   

                <div class="row">
                  <h2 class="mrgn-btm-1rem"><strong>EzyPay</strong></h2>
                  <div class="col-md-6" *ngIf="mids?.vm_6m_mid">
                    <h2>6 Months</h2>
                    <div class="box-uat row">
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant Account Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_6m_mid+mids?.vm_6m_tid}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant ID:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_6m_mid}}</h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <h3>UAT HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_6m_uat_hashkey}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Prod HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_6m_prod_hashkey}}</h3>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="col-md-6" *ngIf="mids?.vm_12m_mid">
                    <h2>12 Months</h2>
                    <div class="box-uat row">
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant Account Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_12m_mid+mids?.vm_12m_tid}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant ID:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_12m_mid}}</h3>
                        </div>
                      </div>


                      <div class="row">
                        <div class="col-md-6">
                          <h3>UAT HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_12m_uat_hashkey}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Prod HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_12m_prod_hashkey}}</h3>
                        </div>
                      </div>
                    </div>
                  </div>       
                  
                


                  <div class="col-md-6" *ngIf="mids?.vm_18m_mid">
                    <h2>18 Months</h2>
                    <div class="box-uat row">
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant Account Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_18m_mid+mids?.vm_18m_tid}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant ID:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_18m_mid}}</h3>
                        </div>
                      </div>


                      <div class="row">
                        <div class="col-md-6">
                          <h3>UAT HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_18m_uat_hashkey}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Prod HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_18m_prod_hashkey}}</h3>
                        </div>
                      </div>
                    </div>
                  </div>       
                  
                


                  <div class="col-md-6" *ngIf="mids?.vm_24m_mid">
                    <h2>24 Months</h2>
                    <div class="box-uat row">
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant Account Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_24m_mid+mids?.vm_24m_tid}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant ID:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_24m_mid}}</h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <h3>UAT HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_24m_uat_hashkey}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Prod HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.vm_24m_prod_hashkey}}</h3>
                        </div>
                      </div>
                    </div>
                  </div>       
                  
                </div> 
              </div>  


              <h3 class="title-light"> AMEX </h3>
              <div class="row">
                <div class="row ">
                  <div class="box-uat col-md-6">
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant Account Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_mid+mids?.amex_tid}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant ID:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_mid}}</h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <h3>AMEX SE Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{(mids?.amex_mid.slice(0,5) == "02701")?mids?.amex_mid.replace("02701", "920"):mids?.amex_mid}}</h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <h3>UAT HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_uat_hashkey}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Prod HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_prod_hashkey}}</h3>
                        </div>
                      </div>
                    </div>
                </div>   

                <div class="row">
                  <h2 class="mrgn-btm-1rem"><strong>EzyPay</strong></h2>
                  <div class="col-md-6" *ngIf="mids?.amex_6m_mid">
                    <h2>6 Months</h2>
                    <div class="box-uat row">
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant Account Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_6m_mid+mids?.amex_6m_tid}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant ID:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_6m_mid}}</h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <h3>AMEX SE Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{(mids?.amex_6m_mid.slice(0,5) == "02701")?mids?.amex_6m_mid.replace("02701", "920"):mids?.amex_6m_mid}}</h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <h3>UAT HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_6m_uat_hashkey}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Prod HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_6m_prod_hashkey}}</h3>
                        </div>
                      </div>
                    </div>
                  </div>


                  <div class="col-md-6" *ngIf="mids?.amex_12m_mid">
                    <h2>12 Months</h2>
                    <div class="box-uat row">
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant Account Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_12m_mid+mids?.amex_12m_tid}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant ID:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_12m_mid}}</h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <h3>AMEX SE Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{(mids?.amex_12m_mid.slice(0,5) == "02701")?mids?.amex_12m_mid.replace("02701", "920"):mids?.amex_12m_mid}}</h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <h3>UAT HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_12m_uat_hashkey}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Prod HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_12m_prod_hashkey}}</h3>
                        </div>
                      </div>
                    </div>
                  </div>       
                  
                


                  <div class="col-md-6" *ngIf="mids?.amex_18m_mid">
                    <h2>18 Months</h2>
                    <div class="box-uat row">
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant Account Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_18m_mid+mids?.amex_18m_tid}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant ID:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_18m_mid}}</h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <h3>AMEX SE Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{(mids?.amex_18m_mid.slice(0,5) == "02701")?mids?.amex_18m_mid.replace("02701", "920"):mids?.amex_18m_mid}}</h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <h3>UAT HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_18m_uat_hashkey}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Prod HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_18m_prod_hashkey}}</h3>
                        </div>
                      </div>
                    </div>
                  </div>       
                  
                


                  <div class="col-md-6" *ngIf="mids?.amex_24m_mid">
                    <h2>24 Months</h2>
                    <div class="box-uat row">
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant Account Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_24m_mid+mids?.amex_24m_tid}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Merchant ID:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_24m_mid}}</h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <h3>AMEX SE Number:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{(mids?.amex_24m_mid.slice(0,5) == "02701")?mids?.amex_24m_mid.replace("02701", "920"):mids?.amex_24m_mid}}</h3>
                        </div>
                      </div>

                      <div class="row">
                        <div class="col-md-6">
                          <h3>UAT HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_24m_uat_hashkey}}</h3>
                        </div>
                      </div>
                      <div class="row">
                        <div class="col-md-6">
                          <h3>Prod HashKey:</h3>
                        </div>
                        <div class="col-md-6">
                          <h3>{{mids?.amex_24m_prod_hashkey}}</h3>
                        </div>
                      </div>
                    </div>
                  </div>       
                  
                </div> 
              </div>  

                  

                <div class="row">
                  <h3 class="title-primary text-center"><strong>User Acceptance Test (UAT) Confirmation </strong></h3>

                  <h3 class="text-center">After completing the UAT, please download, fill up, scan and upload both Merchant Declaration Form and UAT Sign Off Form</h3>
                  <div class="row">
                    <div class="col-md-6 text-center">
                      <!-- <h3>Merchant Declaration Form</h3>
                      <button type="button" class="btn btn-primary btn-block center" (click)="downloadMDF()" >Download</button>
                      <a #mdfDownload download [href]="'assets/cards/merchant_declaration_form.pdf'"  hidden></a> -->
                      <a #mdfDownload download [href]="'assets/cards/merchant_declaration_form.pdf'" class="btn btn-primary btn-block center" >Download Merchant Declaration Form<i class="ti-download" aria-hidden="true"></i></a>


                           
                    </div>
                            
                    <div class="col-md-6 text-center">
                      <!-- <h3>UAT Sign Off Form</h3>
                      
                      <button type="button" class="btn btn-primary btn-block center" (click)="downloadUSO()">Download</button>
                      <a #uatsoDownload download [href]="'assets/cards/UAT_Sign_Off(eBPG).pdf'"  hidden></a> -->
                      <a #uatsoDownload download class="btn btn-primary btn-block center" [href]="'assets/cards/UAT_Sign_Off(eBPG).pdf'">Download UAT Sign Off Form<i class="ti-download" aria-hidden="true"></i></a>
                    </div>   
                  </div> 
                  <div class="row">
                    <div class="col-md-6">
                      <div class="group">

                        <div class="row">
                          <div class="col-md-12">
                              <div class="row">
                                  <div class="col-md-12">
                                      <h5>
                                          Upload Merchant Declaration Form* <br>
                                      </h5>
                                      <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="uatMerchantDeclarationSignOff">
                                          <input (change)="addDoc('uat_cards_merchant_declaration_signoff', $event, false, submissionId)" accept=".pdf, application/pdf,image/jpg, image/jpeg, image/png" #uatMerchantDeclarationSignOffInput type="file" name="uatMerchantDeclarationSignOff"/>
                                      </div>
                                      <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="!uatMerchantDeclarationSignOff">
                                          <a [href]="getFileUrl(uatMerchantDeclarationSignOff)" download class="link" title="Download">Download</a> &nbsp; &emsp;
                                          <a *ngIf="!uatCompleted" (click)="uatMerchantDeclarationSignOff = null; uatMerchantDeclarationSignOffInput.value = ''; uploader.queue[0].progress = 0; deleteDoc('uat_cards_merchant_declaration_signoff')" class="link">Delete</a>
                                      </div>
                                  </div>
                              </div>
                              <div class="row" [hidden]="valid || docsValid">
                                  <div class="col-md-12">
                                      <label class="red">All documents marked with a * are required</label>
                                  </div>
                              </div>
                              <!-- <div *ngIf="uploader" [hidden]="uatMerchantDeclarationSignOff">
                                  Upload Progress: {{uploader.queue[0] ? uploader.queue[0].progress : 0}}%
                                  <div class="progress">
                                      <div class="progress-bar progress-bar-success" role="progressbar" [ngStyle]="{ 'width': (uploader.queue[0] ? uploader.queue[0].progress : 0) + '%' }">
                                          <span style="opacity: 0">...</span>
                                      </div>
                                  </div>
                              </div> -->
                          </div>
                        </div>

                      </div>
                    </div>
                    <div class="col-md-6">
                      <div class="group">

                        <div class="row">
                          <div class="col-md-12">
                              <div class="row">
                                  <div class="col-md-12">
                                      <h5>
                                          Upload UAT Sign Off Form* <br>
                                      </h5>
                                      <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="uatSignOff">
                                          <input (change)="addDoc('uat_cards_ecom_signoff', $event, false, submissionId)" accept=".pdf, application/pdf,image/jpg, image/jpeg, image/png" #uatSignOffInput type="file" name="uatSignOff"/>
                                      </div>
                                      <div class="boxx" style="padding: 5px 5px 5px 5px" [hidden]="!uatSignOff">
                                          <a [href]="getFileUrl(uatSignOff)" download class="link" title="Download">Download</a> &nbsp; &emsp;
                                          <a *ngIf="!uatCompleted" (click)="uatSignOff = null; uatSignOffInput.value = ''; uploader.queue[0].progress = 0; deleteDoc('uat_cards_ecom_signoff')" class="link">Delete</a>
                                      </div>
                                  </div>
                              </div>
                              <div class="row" [hidden]="valid || docsValid">
                                  <div class="col-md-12">
                                      <label class="red">All documents marked with a * are required</label>
                                  </div>
                              </div>
                              <!-- <div *ngIf="uploader" [hidden]="uatSignOff">
                                  Upload Progress: {{uploader.queue[0] ? uploader.queue[0].progress : 0}}%
                                  <div class="progress">
                                      <div class="progress-bar progress-bar-success" role="progressbar" [ngStyle]="{ 'width': (uploader.queue[0] ? uploader.queue[0].progress : 0) + '%' }">
                                          <span style="opacity: 0">...</span>
                                      </div>
                                  </div>
                              </div> -->
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  <div class="row">
                    <div class="col-md-6">
                      <div class="group">

                        <div class="row">
                          <div class="col-md-12">
                              <div class="row">
                                  <div class="col-md-12">
                                      <h3> Do state the expected Go-Live date* </h3>
                                      <my-date-picker name="mydate" [options]="myDatePickerOptions" [disabled]="disabledGoLiveDate" [(ngModel)]="dateModel" required></my-date-picker>
                                      
                                  </div>
                              </div>
                              <div class="row" [hidden]="valid || dateModel">
                                  <div class="col-md-12">
                                      <label class="red">Please choose a Go-Live date </label>
                                  </div>
                              </div>
                              <!-- <div *ngIf="uploader" [hidden]="uatSignOff">
                                  Upload Progress: {{uploader.queue[0] ? uploader.queue[0].progress : 0}}%
                                  <div class="progress">
                                      <div class="progress-bar progress-bar-success" role="progressbar" [ngStyle]="{ 'width': (uploader.queue[0] ? uploader.queue[0].progress : 0) + '%' }">
                                          <span style="opacity: 0">...</span>
                                      </div>
                                  </div>
                              </div> -->
                          </div>
                        </div>

                      </div>
                    </div>
                  </div>
                  

                </div>

                <div class="row" style="text-align: initial;"  *ngIf="!uatCompleted">
                    <div class="col-md-12">
                        <div class="checkbox-default">
                            <label class="norm" for="doneUat"> 
                                <input type="checkbox" name="doneUat" id="doneUat" [(ngModel)]="doneUat" required data-rules="required" data-error-mes="Please tick this before submission."> <span></span>
                                  
                                  I/We hereby CONFIRM that the User Acceptance Test for Cards Payment Gateway was successful with no open defect/issues and ready to go to Production. 
                                  Maybank shall not be held responsible for any failure due to improper/incomplete Payee User Acceptance Test.  
                                  

                            </label>
                            <br>
                        </div>
                        <div class="col-md-12" [hidden]="valid || doneUat">
                            <label class="red">Please tick this before submission. </label>
                        </div>
                    </div>
                </div>
              <div  id="save_cards_uat_live" *ngIf="!uatCompleted">
                <div class="col-md-3">
                  
                </div>
                <div class="col-md-6">
                </div>         
                <div class="col-md-3">
                  <button type="submit" class="btn btn-primary btn-block center" >Submit</button>
                </div>   

                
              </div>
            </form>
      </div>
    </div>
  </div>
</div>
</section>
</div>